/* eslint-disable react/jsx-max-depth */
import { memo } from 'react';

import { ExternalLink } from '@doger/ui/components/ui/link';

import { LogAmplitudeEventOnMount } from '@doger/chat/shared/analytics';

import styles from './terms-of-service.module.scss';

const lastUpdated = '1.09.2025';

export const TermsOfServicePage = memo(() => (
  <>
    <LogAmplitudeEventOnMount event='Terms of Service Page Viewed' />

    <div className={styles.termsOfServicePage}>
      <div className={styles.container}>
        <h1 className={styles.title}>TERMS OF USE</h1>

        <div className={styles.content}>
          <div className={styles.versionInfo}>
            <p className={styles.paragraph}>
              V.1.0. Last Updated {lastUpdated}
            </p>
          </div>

          <section className={styles.section}>
            <p className={styles.paragraph}>
              <strong>
                PLEASE READ THESE TERMS OF USE CAREFULLY ("TERMS"). BY ACCESSING
                THE WEBSITE OR/AND USING ANY SERVICES PROVIDED YOU EXPRESS YOUR
                INFORMED CONSENT TO THE PROVISIONS OF TERMS OF USE AND PRIVACY
                POLICY AND THEY WILL BE BOUNDING FOR YOU. IF YOU DO NOT AGREE TO
                THESE TERMS OF USE OR PRIVACY POLICY, YOU SHALL LEAVE THE
                WEBSITE AND RESTRAIN FROM USING SERVICES.
              </strong>
            </p>
            <p className={styles.paragraph}>
              <strong>
                THESE TERMS OF USE REPRESENT A STANDARD DOCUMENT APPLYING TO ANY
                AND ALL USERS OF THE SERVICES, AND YOU ARE NOT ENTITLED TO
                CHANGE THEM OR ACT IN ANY WAY INCONSISTENT WITH THE PRESENT
                TERMS OF USE.
              </strong>
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>1. DEFINITIONS</h2>
            <p className={styles.paragraph}>
              <strong>1.1 User</strong> – any of individual or business User
              which is using the Application;
            </p>
            <p className={styles.paragraph}>
              <strong>1.2 Services/Application</strong> means the AI-powered
              software application and data intelligence platform known as
              "DOGER", which is designed to:
            </p>
            <ol className={styles.simpleList}>
              <li>
                <span className={styles.counter}>1.2.1.</span> Aggregate,
                analyze, and monitor publicly available information from a wide
                range of sources, including but not limited to government
                entities, public procurement portals (tenders, contracts, bids),
                and other corporate registries;
              </li>
              <li>
                <span className={styles.counter}>1.2.2.</span> Provide tracking,
                search, and analytical tools to identify connections, assess
                risks, and generate insights about the aforementioned entities
                and their activities;
              </li>
              <li>
                <span className={styles.counter}>1.2.3.</span> Deliver the
                results of such analysis to the User in the form of reports,
                visualizations, dashboards, alerts, and notifications;
              </li>
              <li>
                <span className={styles.counter}>1.2.4.</span> Include any
                updates, modifications, or new features added to the platform
                from time to time.
              </li>
            </ol>
            <p className={styles.paragraph}>
              <strong>
                which are available at the Website{' '}
                <ExternalLink href='https://doger.layer2state.com'>
                  doger.layer2state.com
                </ExternalLink>
              </strong>
            </p>
            <p className={styles.paragraph}>
              <strong>1.3 Company</strong> means Kuna Tech DMCC incorporated
              under the laws of Dubai, United Arab Emirates, Company number:
              DMCC192968, Licence Number: DMCC-841617, registered address: Unit
              No: 1706, Jumeirah Bay Tower X3, Plot No: JLT-PH2-X3A, Jumeirah
              Lakes Towers, Dubai, the United Arab Emirates which is providing
              You the services of the DOGER.
            </p>
            <p className={styles.paragraph}>
              <strong>1.4 Intellectual Property Rights</strong> means any
              invention, patent, utility model right, copyright and related
              right, registered design, unregistered design right, trade mark,
              trade name, internet domain name, design, service mark, database
              rights, topography rights, rights in get-up and trade dress,
              rights in goodwill or to sue for passing off and any other rights
              of a similar nature or other industrial or intellectual property
              rights owned or used by Company in any part of the world whether
              or not any of the same is registered (or capable of registration),
              including applications and the right to apply for and be granted,
              extensions or renewals of and rights to claim priority from, such
              rights and all equivalent or similar rights or protections which
              subsist now or will subsist in the future
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>2. ACCEPTABLE USE POLICY</h2>
            <p className={styles.paragraph}>
              By our Services ("Application DOGER") in any way (you represent,
              that following obligations of yours have been fulfilled or will be
              fulfilled (in case if they apply for the future relations and
              ongoing obligations):
            </p>
            <ol className={styles.simpleList}>
              <li>
                <span className={styles.counter}>2.1.</span> You have read and
                agreed with the present Terms and the Privacy Policy in full;
              </li>
              <li>
                <span className={styles.counter}>2.2.</span> You have all the
                rights to enter into the present Agreement;
              </li>
              <li>
                <span className={styles.counter}>2.3.</span> You understand and
                accept, that our Company is providing you solely technically
                related services;
              </li>
              <li>
                <span className={styles.counter}>2.4.</span> You will not copy
                the Application or Services except where such copying is
                incidental to normal use;
              </li>
              <li>
                <span className={styles.counter}>2.5.</span> You will not rent,
                lease, sub-license, loan, translate, merge, adapt, vary or
                modify the Application or Services, modify the App or Services,
                or permit them to be combined with, or become incorporated in,
                any other programs or services, not disassemble, decompile,
                reverse-engineer or create derivative works based on the whole
                or any part of the App or other Services; and will comply with
                all technology control or export laws that apply to the
                technology used by the App or other Services.
              </li>
              <li>
                <span className={styles.counter}>2.6.</span> You understand,
                that in case of any breach of the present Terms of Use, We may
                take action as We deem appropriate, including suspending or
                deleting your account, reporting the relevant authorities,
                terminating Services provision for you, suing, etc.
              </li>
              <li>
                <span className={styles.counter}>2.7.</span> You will use our
                Services solely for lawful purposes and will not attempt to
                affect anything within the Services with criminal intent or in a
                manner that adversely affects the reliability of the Services or
                the integrity of our Company Prohibited Activities,
                transactions, and usage of the Services, beside mentioned in
                other clauses specifically of these Terms, include actions
                related to (but not limited to):
                <ol className={styles.simpleList}>
                  <li>
                    <span className={styles.counter}>2.7.1.</span> Money
                    laundering, terrorist financing, proliferation of weapons of
                    mass destruction;
                  </li>
                  <li>
                    <span className={styles.counter}>2.7.2.</span> Human
                    trafficking;
                  </li>
                  <li>
                    <span className={styles.counter}>2.7.3.</span> Any goods or
                    services that are illegal;
                  </li>
                  <li>
                    <span className={styles.counter}>2.7.4.</span> Any goods or
                    services, promotion, offer or marketing of which would
                    violate copyrights, industrial property rights or other
                    rights of any person;
                  </li>
                </ol>
              </li>
              <li>
                <span className={styles.counter}>2.8.</span> You shall not
                misuse the Application or the Services to cause any harm,
                damage, losses or interference for users, any third parties,
                Company, as well as the operation of the Application and/or
                provision of the Services. Under no circumstance You shall use
                the Application or Services to:
                <ol className={styles.simpleList}>
                  <li>
                    <span className={styles.counter}>2.8.1.</span> Publish,
                    post, send, upload, submit, display or disseminate any
                    information or material and/or otherwise make available or
                    engage in any conduct that is unlawful, discriminatory,
                    harassing, libelous, defamatory, abusive, threatening,
                    harmful, offensive, obscene or otherwise objectionable;
                  </li>
                  <li>
                    <span className={styles.counter}>2.8.2.</span> Display,
                    upload or transmit material that encourages conduct that may
                    constitute a criminal offense, result in civil liability or
                    otherwise violate or breach any applicable laws, regulations
                    or code of practice;
                  </li>
                </ol>
              </li>
              <li>
                <span className={styles.counter}>2.9.</span> Interfere or
                violate the legal right of others or violate other violate usage
                conditions of the Application or the Services;
              </li>
              <li>
                <span className={styles.counter}>2.10.</span> Violate any
                applicable laws, regulations or these Terms, Privacy Policy;
              </li>
              <li>
                <span className={styles.counter}>2.11.</span> Violate, infringe
                or misappropriately use any Intellectual Property Right of any
                person (such as copyright, trademarks, patents, or trade
                secrets, or other proprietary rights of any party) or commit a
                tort;
              </li>
              <li>
                <span className={styles.counter}>2.12.</span> Interfere with,
                disrupt, negatively affect or inhibit other Users from using the
                Application, or Services or links to the Application, or damage,
                disable, overburden or impair the functioning of the
                Application, or Services, or our servers or any networks
                connected to any of our servers in any manner;
              </li>
              <li>
                <span className={styles.counter}>2.13.</span> Engage in or
                promote any activity that violates these Terms;
              </li>
              <li>
                <span className={styles.counter}>2.14.</span> Mislead or deceive
                Us;
              </li>
              <li>
                <span className={styles.counter}>2.15.</span> Upload files that
                contain viruses, Trojan horses, worms, time bombs, cancelbots,
                corrupted files, or any other similar software or programs that
                may damage the operation of the Application or Services or the
                operation of another's computer or property;
              </li>
              <li>
                <span className={styles.counter}>2.16.</span> Make available any
                content which is false, misleading and/or promoting illegal
                activities;
              </li>
              <li>
                <span className={styles.counter}>2.17.</span> Access any
                content, area or functionality of the Service, Application that
                you are prohibited or restricted from accessing or attempt to
                bypass or circumvent measures employed to prevent or limit Your
                access to any content, area or functionality of Application or
                Service;
              </li>
              <li>
                <span className={styles.counter}>2.18.</span> Attempt to gain
                unauthorized access to any Services, Application, computer
                systems, or networks connected to any of our servers through
                hacking, password mining, or any other means.
              </li>
            </ol>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>3. SERVICES</h2>
            <ol className={styles.simpleList}>
              <li>
                <span className={styles.counter}>3.1.</span> Users can make
                limited requests without logging in. After a certain number of
                requests, Users may be required to register on the Website /
                perform other required actions by the Company represents in
                order to proceed with further research (such as may be filling
                forms, leaving reviews etc).
              </li>
              <li>
                <span className={styles.counter}>3.2.</span> Please be advised
                that our services and features are currently in a Beta Testing
                phase and are provided on an "as is" and "as available" basis
                (more information is provided in the "Disclaimers" Section)
                <ol className={styles.simpleList}>
                  <li>
                    <span className={styles.counter}>3.2.1.</span> Beta Status:
                    You are using an early, unreleased version of our service.
                    It may contain bugs, errors, and instability.
                  </li>
                  <li>
                    <span className={styles.counter}>3.2.2.</span> Potential
                    Issues: You may encounter interruptions, loss of data,
                    errors, or other unexpected behavior. Performance and
                    quality may not meet the standards of a final product.
                  </li>
                  <li>
                    <span className={styles.counter}>3.2.3.</span> Continuous
                    Evolution: The service will change frequently. We may add,
                    modify, or remove features at any time without prior notice.
                  </li>
                  <li>
                    <span className={styles.counter}>3.2.4.</span> Future
                    Requirements: Access to the service or certain features may
                    become subject to mandatory registration, account
                    verification, fees, or subscription models in the future, at
                    our sole discretion.
                  </li>
                </ol>
              </li>
            </ol>
            <p className={styles.paragraph}>
              By using the service, you acknowledge that you are using a beta
              product and agree to assume any and all risks associated with its
              use. We appreciate your understanding and feedback as we work to
              improve the Application.
            </p>
            <p className={styles.paragraph}>
              <strong>3. AI-Generated content;</strong> This Service includes
              functionality powered by artificial intelligence ("AI-Powered
              Solution") that processes information from publicly available
              sources and provides informational summaries. Such AI-Generated
              Content is offered on an "as is" basis as part of a beta release,
              intended solely for testing and evaluation. Content generated by
              the Service may be incomplete, inaccurate, or contain errors; it
              does not constitute legal advice, may not be relied upon in court
              or regulatory proceedings, and should be treated solely as a
              general informational reference. Use of such AI-Generated Content
              is entirely at your own risk.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>4. LINKING AND FRAMING</h2>
            <ol className={styles.simpleList}>
              <li>
                <span className={styles.counter}>4.1.</span> Linking to Our
                Service (website also). You may link to the homepage of our
                Site, provided you do so in a fair and lawful manner that does
                not damage our reputation or suggest any form of association,
                approval, or endorsement by us where none exists.
              </li>
              <li>
                <span className={styles.counter}>4.2.</span> Framing and
                Mirroring. You must not frame, mirror, or otherwise embed any
                part of this Site or its content on any other website or service
                without our prior express written consent.
              </li>
              <li>
                <span className={styles.counter}>4.3.</span> Third-Party Links.
                This Site may contain links to third-party websites and online
                resources. These links are provided solely for your convenience
                and informational purposes.
              </li>
              <li>
                <span className={styles.counter}>4.4.</span> Disclaimer for
                External Content. We have no control over the content of these
                third-party sites and resources. Accordingly, you acknowledge
                and agree that:
                <ol className={styles.simpleList}>
                  <li>
                    <span className={styles.counter}>4.4.1.</span> We are not
                    responsible for the availability, accuracy, or legality of
                    such external sites.
                  </li>
                  <li>
                    <span className={styles.counter}>4.4.2.</span> The inclusion
                    of a link does not imply our endorsement of the site, its
                    operators, or any content, advertising, products, or
                    services available on it.
                  </li>
                  <li>
                    <span className={styles.counter}>4.4.3.</span> We shall not
                    be responsible or liable for any loss or damage caused by
                    your use of or reliance on any content, goods, or services
                    available through any such third-party site.
                  </li>
                </ol>
              </li>
            </ol>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              5. DISCLAIMER OF ACCURACY AND LIABILITY
            </h2>
            <ol className={styles.simpleList}>
              <li>
                <span className={styles.counter}>5.1.</span> The information on
                this Site, Services are compiled and presented through automated
                processes utilizing artificial intelligence (AI). Please be
                aware of the following important limitations:
                <ol className={styles.simpleList}>
                  <li>
                    <span className={styles.counter}>5.1.1.</span>{' '}
                    <strong>Automated Processing:</strong> The information is
                    gathered by AI systems automatically. It is not subject to
                    continuous, 24/7 human review, verification, or monitoring.
                  </li>
                  <li>
                    <span className={styles.counter}>5.1.2.</span>{' '}
                    <strong>No Accuracy Guarantee:</strong> We do not guarantee
                    or warrant, express or implied, the reliability, accuracy,
                    timeliness, or completeness of any information provided by
                    our AI systems. The Site, Services and all its content are
                    provided on an <strong>"AS IS, AS AVAILABLE" basis.</strong>
                  </li>
                  <li>
                    <span className={styles.counter}>5.1.3.</span>{' '}
                    <strong>Errors:</strong> We expressly disclaim any
                    responsibility for errors or omissions resulting from the
                    AI's interpretation, parsing, or processing of source
                    information.
                  </li>
                  <li>
                    <span className={styles.counter}>5.1.4.</span>{' '}
                    <strong>Affiliate Disclaimer:</strong> Neither Company, nor
                    any of its affiliates, employees, agents, or third-party
                    content providers shall be liable for any loss resulting
                    from the use or unavailability of information or content on
                    this Site, Application.
                  </li>
                </ol>
              </li>
              <li>
                <span className={styles.counter}>5.2.</span>{' '}
                <strong>
                  USER ACCESSES THIS SITE AT HIS OR HER OWN RISK. ANY AND ALL
                  WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR
                  PURPOSE ARE SPECIFICALLY DISCLAIMED.
                </strong>
              </li>
              <li>
                <span className={styles.counter}>5.3.</span>{' '}
                <strong>
                  IN NO EVENT WILL WE OR OUR AFFILIATES BE LIABLE FOR ANY
                  DIRECT, INDIRECT, CONSEQUENTIAL, OR INCIDENTAL DAMAGES ARISING
                  FROM YOUR USE OF THIS SITE OR RELIANCE ON ITS CONTENT,
                  INCLUDING BUT NOT LIMITED TO ANY LOSS OF PROFITS OR DATA, EVEN
                  IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                  THIS DISCLAIMER APPLIES TO ANY DAMAGE OR INJURY RESULTING FROM
                  THE NEGLIGENCE OR OMISSION OF COMPANY, COMPUTER VIRUSES,
                  TELECOMMUNICATIONS ERRORS, OR UNAUTHORIZED ACCESS TO YOUR
                  INFORMATION.
                </strong>
              </li>
            </ol>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>6. IP MATTERS</h2>
            <ol className={styles.simpleList}>
              <li>
                <span className={styles.counter}>6.1.</span> Company retains all
                rights, title and interest in and to the Application and the
                Services, whether express or implied, including all copyrights,
                patents, trade secrets, trademarks, other intellectual property
                rights, trade names, logos, slogans, custom graphics, button
                icons, scripts, videos, text, images, software, code, files,
                content, information and other material available in the
                Application and other Intellectual Property Rights as prescribed
                in the 'Section' Definitions of these Terms.
              </li>
              <li>
                <span className={styles.counter}>6.2.</span> Accessing the App
                and using the Services does not vest You with any right, title
                or interest in the Intellectual Property and other rights to
                content which is accessible in the Application unless otherwise
                is provided in this Agreement.
              </li>
              <li>
                <span className={styles.counter}>6.3.</span> In order to use the
                Application and / or any other Service, You are granted
                personal, non-exclusive, limited, non-assignable,
                non-transferrable, royalty free, revocable license to use the
                Application/ Services subject to all limitations contained
                herein.
              </li>
            </ol>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              7. AMENDMENTS AND APPLICATION UPDATES
            </h2>
            <ol className={styles.simpleList}>
              <li>
                <span className={styles.counter}>7.1.</span> We reserve the
                right to unilaterally change the present Terms anytime at our
                sole discretion. In the event of significantly updating these
                Terms, We may ask you to re-consent to the updated Terms before
                any changes take effect. In the event that significant changes
                or any other are unacceptable to You, We ask You to stop using
                Our Services immediately. All changes will indicate the date
                from which they will take effect.
              </li>
              <li>
                <span className={styles.counter}>7.2.</span> You can always find
                the latest version of the Terms on the Website/App if any. If
                you use our Services after the changes come into effect, We deem
                it as your consent to the changes.
              </li>
              <li>
                <span className={styles.counter}>7.3.</span> From time to time,
                we may automatically update the Application and change the
                Services to improve performance, enhance functionality, reflect
                changes to the operating system or address security issues.
              </li>
            </ol>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>8. INDEMNITY</h2>
            <ol className={styles.simpleList}>
              <li>
                <span className={styles.counter}>8.1.</span> Indemnification.
                You agree to indemnify, defend, and hold harmless Company, its
                parents, subsidiaries, affiliates, successors, assigns,
                licensors, service providers, and its and their officers,
                agents, and employees (collectively, the "Indemnified Parties")
                from and against any and all liabilities, damages, losses,
                costs, and expenses (including reasonable attorneys' fees and
                costs) arising out of or relating to any third-party claim,
                demand, or action to the extent it is based upon or alleges:
                <ol className={styles.simpleList}>
                  <li>
                    <span className={styles.counter}>8.1.1.</span> Your access
                    to or use of the Services or any related content;
                  </li>
                  <li>
                    <span className={styles.counter}>8.1.2.</span> Your
                    violation of these Terms of Use;
                  </li>
                  <li>
                    <span className={styles.counter}>8.1.3.</span> Your User
                    Content; or
                  </li>
                  <li>
                    <span className={styles.counter}>8.1.4.</span> the
                    infringement by you, or any third party using your account
                    (if any) of any intellectual property or other right of any
                    person or entity.
                  </li>
                </ol>
              </li>
            </ol>
            <p className={styles.paragraph}>
              This indemnification obligation will survive the termination of
              your use of the Site and these Terms of Use.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>9. TERMINATION</h2>
            <ol className={styles.simpleList}>
              <li>
                <span className={styles.counter}>9.1.</span> We may end your
                rights to use the Application and Services at any time by
                contacting you if we consider that you have broken these Terms
                of Use or just based on our own discretion.
              </li>
              <li>
                <span className={styles.counter}>9.2.</span> In case if decide
                to terminate your rights to use the App and Services:
                <ol className={styles.simpleList}>
                  <li>
                    <span className={styles.counter}>9.2.1.</span> you must stop
                    all activities authorized by these Terms of Use, including
                    your use of the Application and any Services;
                  </li>
                </ol>
              </li>
            </ol>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>
              10. APPLICABLE LAW AND ARBITRATION
            </h2>
            <ol className={styles.simpleList}>
              <li>
                <span className={styles.counter}>10.1.</span> All questions
                concerning the construction, validity, enforcement and
                interpretation of these Terms shall be governed by and construed
                and enforced in accordance with the laws of English (Applicable
                Law).
              </li>
              <li>
                <span className={styles.counter}>10.2.</span> Arbitration: Any
                dispute, controversy, or claim arising out of or relating to
                these Terms, including their formation, validity, or
                termination, shall be finally settled under the Arbitration
                Rules of the Dubai Multi Commodities Centre (DMCC) Arbitration
                Centre, which rules are deemed to be incorporated by reference
                into this clause.
                <ol className={styles.simpleList}>
                  <li>
                    <span className={styles.counter}>10.2.1.</span> The seat, or
                    legal place, of arbitration shall be the DMCC, Dubai, United
                    Arab Emirates.
                  </li>
                  <li>
                    <span className={styles.counter}>10.2.2.</span> The tribunal
                    shall consist of one (1) arbitrator.
                  </li>
                  <li>
                    <span className={styles.counter}>10.2.3.</span> The language
                    of the arbitration shall be English.
                  </li>
                  <li>
                    <span className={styles.counter}>10.2.4.</span> The award of
                    the arbitrator shall be final and binding on the parties.
                  </li>
                </ol>
              </li>
            </ol>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>11. MISCELLANEOUS</h2>
            <ol className={styles.simpleList}>
              <li>
                <span className={styles.counter}>11.1.</span>{' '}
                <strong>Severability.</strong> If any of these terms are
                determined to be invalid, unlawful or unenforceable to any
                extent, such term shall be excluded from these Terms, and the
                remaining terms shall continue to be valid to the fullest extent
                permitted by law.
              </li>
              <li>
                <span className={styles.counter}>11.2.</span>{' '}
                <strong>LIMITED ASSIGNMENT.</strong> We reserve the rights to
                assign this agreement in part or in full to third parties.
              </li>
              <li>
                <span className={styles.counter}>11.3.</span> These Terms shall
                be valid as long as You have access to our Services and You use
                them. These Terms shall not expire upon termination of Your
                access to the Services.
              </li>
            </ol>
          </section>
        </div>
      </div>
    </div>
  </>
));
